<div>
    <div class="tab-main">
        <div class="tab-data justify-content-between align-items-center">
            <div class="input_auth">
                <i class="fas fa-search"></i>
                <input placeholder="Search by name or id" />
            </div>
            <div class="plus-license">
                <button class="license"><i class="fa-solid fa-plus"></i>New Integration</button>
            </div>
        </div>
        <div class="table-responsive">
            <table class="w-100 f-14 normal_table">
                <tr>
                    <th></th>
                    <th class="fw-600 f-12">Company Name</th>
                    <th class="fw-600 f-12">Category</th>
                    <th class="fw-600 f-12">Last Synced</th>
                    <th class="fw-600 f-12">Active</th>
                    <th></th>
                </tr>
                <tbody class="table_body">
                    <tr>
                        <td><img src="/assets/images/stripe-logo.png" alt="stripe-logo"/></td>
                        <td>Stripe</td>
                        <td><button class="pay-btn">Payment</button></td>
                        <td>05 August 2020, 02 : 22 PM<button class="pay-btn sync-btn">Sync Now</button></td>
                        <td class="table_data">
                            <label class="switch">
                              <input type="checkbox" checked>
                              <span class="slider round"></span>
                            </label>
                          </td>
                        <td>
                            <i class="fas fa-ellipsis-v f-20"></i>
                        </td>
                    </tr>
                    <tr>
                        <td><img src="/assets/images/givex-logo.png" alt="givex-logo"/></td>
                        <td>GiveX</td>
                        <td class="d-flex"><button class="loyal-btn">Loyalty</button><button class="gift-card">Gift Card</button></td>
                        <td>05 August 2020, 02 : 22 PM<button class="pay-btn sync-btn">Sync Now</button></td>
                        <td class="table_data">
                            <label class="switch">
                              <input type="checkbox" checked>
                              <span class="slider round"></span>
                            </label>
                          </td>
                        <td>
                            <i class="fas fa-ellipsis-v f-20"></i>
                        </td>
                    </tr>
                    <tr>
                        <td><img src="/assets/images/gusto-logo.png" alt="gusto-logo"/></td>
                        <td>Gusto</td>
                        <td><button class="pay-roll">Payroll</button></td>
                        <td>05 August 2020, 02 : 22 PM<button class="pay-btn sync-btn">Sync Now</button></td>
                        <td class="table_data">
                            <label class="switch">
                              <input type="checkbox" checked>
                              <span class="slider round"></span>
                            </label>
                          </td>
                        <td>
                            <i class="fas fa-ellipsis-v f-20"></i>
                        </td>
                    </tr>
                    <tr>
                        <td><img src="/assets/images/marketman-logo.png" alt="marketman-logo"/></td>
                        <td>MarketMan</td>
                        <td><button class="inventory">Inventory</button></td>
                        <td>05 August 2020, 02 : 22 PM<button class="pay-btn sync-btn">Sync Now</button></td>
                        <td class="table_data">
                            <label class="switch">
                              <input type="checkbox" checked>
                              <span class="slider round"></span>
                            </label>
                          </td>
                        <td>
                            <i class="fas fa-ellipsis-v f-20"></i>
                        </td>
                    </tr>
                    <tr>
                        <td><div class="sale-tax">%</div></td>
                        <td>Sales Tax</td>
                        <td><button class="inventory">TAX</button></td>
                        <td>05 August 2020, 02 : 22 PM<button class="pay-btn sync-btn">Sync Now</button></td>
                        <td class="table_data">
                            <label class="switch">
                              <input type="checkbox" checked>
                              <span class="slider round"></span>
                            </label>
                          </td>
                        <td>
                            <i class="fas fa-ellipsis-v f-20"></i>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="d-flex justify-content-between align-items-center show-entrie">
                <!-- <app-paginate-select></app-paginate-select> -->
                <div class="col-4 fw-400 f-12 text-center">
                    Showing 1 to
                    <span>10</span> of
                    <span>20</span> entries
                </div>

                <div class="col-4 d-flex justify-content-end">
                    <!-- <pagination-controls class="pagination" (pageChange)="updatePage($event)">
                    </pagination-controls> -->
                </div>
            </div>
        </div>
    </div>
</div>